export default __webpack_public_path__ + "static/media/C50OR100.16e24dc2.mp3";